import Alert from '@mui/material/Alert'
import { Post, Submission } from '@global/types'
import { Target } from './components'
import { t } from '@lingui/core/macro'

interface Props {
  submission: Submission
  rerunDatasetPost: (submission: Submission, post: Post) => void
  downloadPostZip: (post: Post) => void
}

export const Targets = ({ submission, rerunDatasetPost, downloadPostZip }: Props) => (
  <>
    {submission?.dataset_posts?.map(post => (
      <div key={post.id}>
        {post.target ? (
          <Target
            post={post}
            submission={submission}
            rerunDatasetPost={rerunDatasetPost}
            downloadPostZip={downloadPostZip}
          />
        ) : (
          <Alert variant="outlined" severity="error">
            {t`The target this submission was sent to has been removed from the Claravine platform`}
          </Alert>
        )}
        <Alert variant="outlined" severity="info">
          <div>
            {t`Remote job ID:`}
            {post.remote_job_id}
          </div>
          <div>{post.api_response}</div>
        </Alert>
      </div>
    ))}
  </>
)
